import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

import "@style/Admin.scss";
import RightTimeApi from "@/API";
import { LoadingOverlay } from "./CustomAlert";
import Request from "../elements/Request";
import TestDetailsModal from "@modals/TestDetailsModal";
import ReusableCodeResult from "@modals/ReusableCodeResult";
import Enums from "@/enums";

export default function CompanyRequestTab(props: any) {
  const { updateSpinner, activeTab, company, adminPerms } = props.tabData;
  const [companyId, updateCompanyId] = useState(0);
  const [loading, setLoading] = useState(false); // State to manage loading overlay
  const [resetKey, setResetKey] = useState(0); // Force Request component to reset
  const [createdTestId, setCreatedTestId] = useState(null); // Track created test for modal
  const [createdTestInstanceId, setCreatedTestInstanceId] = useState(null); // Track test instance ID
  const [reusableCode, setReusableCode] = useState("");
  const isSystemAdmin = (() => {
    const rolePerms = Enums && Enums.ROLE_PERMS ? Enums.ROLE_PERMS : null;
    const systemAdminPerm = rolePerms && rolePerms.SystemAdmin ? rolePerms.SystemAdmin : 254;
    if (!Array.isArray(adminPerms)) return false;
    return adminPerms.some((permission) => {
      if (typeof permission === "number") return permission === systemAdminPerm;
      if (permission && typeof permission === "object") {
        return permission.id === systemAdminPerm || permission.permId === systemAdminPerm || permission.permissionId === systemAdminPerm;
      }
      return false;
    });
  })();

  useEffect(() => {
    if (isOnThisTab()) {
      let c = 0;
      // Only use company if company exists
      if (company) {
        // Prefer props.company over company when both are present
        if (company.id !== companyId)
          c = company.id;
      }
      if (c > 0 && c !== companyId)
        updateCompanyId(c);
    }
  }, [activeTab]);

  if (!isOnThisTab()) return null;

  function isOnThisTab() {
    return activeTab && activeTab === "request";
  }

  const handleTestCreated = (testState) => {
    const sharedCode = String(testState?.reusableCode || "").trim();
    if (sharedCode && !testState?.testData?.id && !testState?.id) {
      setReusableCode(sharedCode);
      return;
    }
    if (testState?.testData?.id) {
      setCreatedTestId(testState.testData.id);
      setCreatedTestInstanceId(testState.testData.testInstanceId);
    } else if (testState?.id) {
      setCreatedTestId(testState.id);
      setCreatedTestInstanceId(testState.testInstanceId);
    }
  };

  function closeReusableCode() {
    setReusableCode("");
    setResetKey((prev) => prev + 1);
  }

  if (isOnThisTab()) {
      return (
        <>
          {loading && <LoadingOverlay />} {/* Show loading overlay if loading */}
          {!createdTestId && !reusableCode && (
            <Request
              key={resetKey}
              companyId={companyId}
              company={company}
              active={isOnThisTab()}
              updateSpinner={updateSpinner}
              onCreate={handleTestCreated}
              adminPerms={adminPerms}
            />
          )}
          {reusableCode && (
            <ReusableCodeResult code={reusableCode} onClose={closeReusableCode} />
          )}
          {createdTestId && (
            <TestDetailsModal
              testId={createdTestId}
              testInstanceId={createdTestInstanceId}
              onClose={() => {
                setCreatedTestId(null);
                setCreatedTestInstanceId(null);
                setResetKey(prev => prev + 1); // Reset form for next test
              }}
              updateSpinner={updateSpinner}
              isSystemAdmin={isSystemAdmin}
              adminPerms={adminPerms}
            />
          )}
        </>
      );
  }
}

